import React from 'react'
import './AppRight.css'


function AppRight() {
    return (
        <div className="appright">
            <h3>WELCOME TO LOVE MY PET</h3>
            <br></br>
            <p>We just started this website and you will be one of the early users in history, one day we will invite you to tell the story</p> 
            <br></br><p>ENJOY THESE CUTIES HERE!</p>
            <br></br>
            {/* <p></p>
            <br></br> */}
            <p>LoveMyPet team  10/25 2020</p>
            <br></br>
            <hr width='100%' color='lightgray' size='1'/>     
            <br></br>
            
             
        </div>
    )
}

export default AppRight
